export default __webpack_public_path__ + "static/media/placeholder_dummy2016-naeherin01-de.3cf0e973.png";